import * as React from 'react';
import * as styles from "../Messages.css";
import { LocalizationService } from '../../../services/LocalizationService';

export interface IPagingProps {
  getNextPage: () => void;
  getPreviousPage: () => void;
  hasNextPage?: boolean;
  isLoading?: boolean;
  pageNumber?: number;
  highlightColor?: string;
  isMobile?: boolean;
  hasDarkBackground?: boolean;
  showPaging?: boolean;
}
export class Paging extends React.Component<IPagingProps> {
  constructor(props: IPagingProps) {
    super(props);
  }

  public render(): JSX.Element {
    const dots: JSX.Element[] = [];
    for (let i = 1; i <= this.props.pageNumber; i++) {
      const isDotActive = this.props.pageNumber === i;
      const isDotDeprecated = this.props.pageNumber - 2 === i;
      let left = -20;
      if (isDotActive) left = this.props.pageNumber === 1 ? 18 : ((this.props.pageNumber === 2 && !this.props.hasNextPage) ? 40 : 29);
      if (i + 1 === this.props.pageNumber) left = this.props.pageNumber === 2 && !this.props.hasNextPage ? 18 : 7;
      dots.push(
        <div
          className={styles.IA_pagingDotClickable}
          key={`paging_dot_${i}`}
          style={{
            left: left,
            opacity: isDotDeprecated ? 0 : 1
          }}
          onClick={() => {
            if (!isDotActive) {
              this.props.getPreviousPage();
            }
          }}
        >
          <div
            className={styles.IA_pagingDot}
            style={{
              backgroundColor: this.props.hasDarkBackground ? (isDotActive ? "#ffffff" : "#ffffff8f") : (isDotActive ? this.props.highlightColor : "#0000001f"),
            }}
          />
        </div>
      );
    }

    if (this.props.hasNextPage || this.props.isLoading) {
      // add next dot
      dots.push(
        <div
          key={`paging_dot_${this.props.pageNumber + 1}`}
          className={styles.IA_pagingDotClickable}
          onClick={() => {
              this.props.getNextPage();
          }}
          style={{
            left: this.props.isLoading ? 115 : this.props.pageNumber === 1 ? 40 : 51,
            opacity: this.props.isLoading ? 0 : 1
          }}
        >
          <div
            className={styles.IA_pagingDot}
            style={{
              backgroundColor: this.props.hasDarkBackground ? "#ffffff8f" : "#0000001f",
            }}
          />
        </div>
      );
      // add the dot that is not visible
      dots.push(
        <div
          key={`paging_dot_${this.props.pageNumber + 2}`}
          className={styles.IA_pagingDotClickable}
          style={{
            left: 115,
            opacity: 0
          }}
        >
          <div className={styles.IA_pagingDot} />
        </div>
      );
    }
    return this.props.isMobile ?
      <div
        className={styles.IA_paging}
      >
        {this.props.hasNextPage &&
          <div
            className={styles.loadMoreButton}
            style={{
              color: this.props.highlightColor
            }}
            onClick={() => {
              this.props.getNextPage();
            }}
          >
            {new LocalizationService().strings.Phonebook_LoadMore}
          </div>
        }
      </div>
      :
      <div
        className={styles.IA_paging}
      >
        <div className={styles.IA_pagingContainer}>
          <div
            className={styles.IA_pagingDotsContainer}
          >
            {this.props.showPaging &&
              dots
            }
          </div>
        </div>
      </div>
  }
}